import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import halaman
import HeroAspirasi from "./LandingPageUdin/Pages/HeroAspirasi/heroaspirasipage";
import QuestionnaireUpdatePage from "./LandingPageUdin/Pages/Questionnaire/QusuionerUpdatePage";

const App: React.FC = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <HeroAspirasi
                handleMenuClick={function (page: string): void {
                  throw new Error("Function not implemented.");
                }}
              />
            }
          />
          <Route path="/questionnaire" element={<QuestionnaireUpdatePage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
